module.exports = __webpack_public_path__ + "static/media/AGBs.f1c53dc2.pdf";